import { render } from "./CrmDealAfterSalesView.vue?vue&type=template&id=5799536c&scoped=true"
import script from "./CrmDealAfterSalesView.vue?vue&type=script&lang=js"
export * from "./CrmDealAfterSalesView.vue?vue&type=script&lang=js"

import "./CrmDealAfterSalesView.vue?vue&type=style&index=0&id=5799536c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5799536c"]])

export default __exports__